import { registerQuery, useQuery } from 'data-fetching-client';
import Raven from 'raven-js';
import { getDataSyncApps } from '../api/syncBridge';
const GET_DATA_SYNC_APPS = registerQuery({
  fieldName: 'getDataSyncApps',
  fetcher: getDataSyncApps
});
export const useDataSyncApps = args => {
  var _args$skip, _data$getDataSyncApps;
  const {
    data,
    loading,
    error,
    networkStatus
  } = useQuery(GET_DATA_SYNC_APPS, {
    onError: err => {
      Raven.captureException(err);
    },
    skip: (_args$skip = args === null || args === void 0 ? void 0 : args.skip) !== null && _args$skip !== void 0 ? _args$skip : false
  });
  return {
    data: (data === null || data === void 0 || (_data$getDataSyncApps = data.getDataSyncApps) === null || _data$getDataSyncApps === void 0 ? void 0 : _data$getDataSyncApps.apps) || [],
    error,
    isLoading: loading,
    networkStatus
  };
};